module.exports = __webpack_public_path__ + "img/pinterest.19819869.png";